import React, { useState, useEffect } from 'react';
import { Select } from '@tencent/spaui';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { getSubaccountFromLocalStorage, setSubaccountToLocalStorage } from './util';
import { isMainAccount } from '../../../consts/multiAccountConfig';

const SubAccountSelectorInner = (props) => {
  const [subaccountList, setSubaccountList] = useState([]);
  const [currentSubaccount, setSubaccount] = useState(getSubaccountFromLocalStorage());

  useEffect(() => {
    if (isMainAccount()) {
      RPCFactory.DMPUpload
        .getSubaccountList()
        .done((data) => {
          if (_.isArray(data.subAccountIds) && data.subAccountIds.length > 0) {
            setSubaccountList(data.subAccountIds);
          }
        })
        .fail((status, msg) => {
          alert(msg ? msg : '请求失败');
        });
    }
  }, []);

  const selectSubaccount = (value) => {
    setSubaccountToLocalStorage(value);
    setSubaccount(value);
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return isMainAccount() && subaccountList.length ? (
    <div className="page-pool">
      {/* <div className="a-tabs-head-right" style={{ top: '-55px' }}>*/}
      {/*  <div className="timely-tips">*/}
      {/*    <span style={{ display: 'block', padding: '2px 4px 0 0' }}>选择子账号</span>*/}
      {/*    <Select*/}
      {/*      // valueFieldName="corpId"*/}
      {/*      // labelFieldName="corpName"*/}
      {/*      data={subaccountList}*/}
      {/*      value={currentSubaccount}*/}
      {/*      onChange={(e, value) => {*/}
      {/*        selectSubaccount(value);*/}
      {/*      }}*/}
      {/*      placeholder="请选择子账号"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/* </div>*/}
    </div>
  ) : null;
};

export const SubAccountSelector = React.memo(SubAccountSelectorInner);
